import React from 'react';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';
import { isEmpty } from '../../../../../../../core/util/empty';

class ExplanationPlanTypePpo extends Base {
  static isVisible = ({ planType }: any) => !isEmpty(planType) && planType.toUpperCase() === 'PPO';

  icon = '/images/insurance_tutorial/03_ppo_hmo.svg';

  render = () => {
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>You have a PPO</H2>

            <P>
              Your plan allows you to visit most doctors in your network&mdash;no referral required.{' '}
              It's got lots of flexibility.
            </P>

            <P>
              Try to visit doctors in your network. Why? You’ll pay less. Going to an out-of-network{' '}
              doctor is often more expensive, and doesn't count towards your in-network deductible.
            </P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default ExplanationPlanTypePpo;
